export const USER_LOGGED_IN = 'userLoggedIn'
export const USER_LOGGED_OUT = 'userLoggedOut'
export const USER_REQUEST_TOKEN = 'requestUserToken'
export const USER_REQUEST_LOGIN = 'requestUserLogin'
export const USER_REQUEST_LOGOUT = 'requestUserLogout'
export const USER_REQUEST_PROFILE = 'requestUserProfile'
export const USER_REQUEST_RESTORE = 'requestUserRestore'

